const snippetType = {
  GLOBAL: { key: "global", label: "Global Snippet" },
  ACCOUNT: { key: "account", label: "Account Snippet" },
  ADVISOR: { key: "advisor", label: "My Snippet" },
};

export default snippetType;
